import SiteHeader from "./components/SiteHeader";
import HeroSection from "./components/HeroSection";
import StatsBar from "./components/StatsBar";
import AboutSection from "./components/AboutSection";
import PlaySection from "./components/PlaySection";
import RulesSection from "./components/RulesSection";
import EligibilitySection from "./components/EligibilitySection";
import JudgingSection from "./components/JudgingSection";
import TracksSection from "./components/TracksSection";
import StoriesSection from "./components/StoriesSection";
import FaqSection from "./components/FaqSection";
import BrandSection from "./components/BrandSection";
import ContactSection from "./components/ContactSection";
import SiteFooter from "./components/SiteFooter";
import ScrollToTopButton from "./components/ScrollToTopButton";

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <StatsBar />
        <AboutSection />
        <PlaySection />
        <RulesSection />
        <EligibilitySection />
        <JudgingSection />
        <TracksSection />
        <StoriesSection />
        <FaqSection />
        <BrandSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <ScrollToTopButton />
    </div>
  );
}